export const tro40DataEn = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.wm.com/us/en/dumpster-rental/40-yard",
      url: "https://www.wm.com/us/en/dumpster-rental/40-yard",
      name: "40 Yard Dumpster Rental | WM",
      primaryImageOfPage: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/40-yard/#primaryimage",
      },
      image: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/40-yard/#primaryimage",
      },
      thumbnailUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/40-yard/40-yd-header.jpg",
      description:
        "Our 40 yard dumpster rentals are ideal for the largest construction, roofing, and remodeling projects. Schedule your rental online today.",
    },
    {
      "@type": "ImageObject",
      inLanguage: "en-US",
      "@id": "https://www.wm.com/us/en/dumpster-rental/40-yard/#primaryimage",
      url: "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/40-yard/40-yd-header.jpg",
      contentUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/40-yard/40-yd-header.jpg",
      width: 545,
      height: 327,
      caption: "40 yard dumpster dimensions",
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.wm.com/us/en/dumpster-rental/40-yard/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.wm.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Dumpster Rental",
          item: "https://www.wm.com/us/en/dumpster-rental",
        },
        { "@type": "ListItem", position: 3, name: "40-Yard" },
      ],
    },
  ],
}

export const tro40ProductDataEn = {
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": "https://www.wm.com/us/en/dumpster-rental/40-yard/#product",
  name: "40 Yard Dumpster Rental | WM",
  image:
    "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/40-yard/40-yd-header.jpg",
  description:
    "Typically measuring 21’11” x 7’ x 7’, the 40 yard dumpster is our largest dumpster size. It is the perfect solution for big home remodel projects, office renovations, roofing, and other construction debris. Order dumpster rentals, schedule delivery or additional pickups of your waste and debris all online using convenient tools like My WM",
  url: "https://www.wm.com/us/en/dumpster-rental/40-yard",
  mainEntityOfPage: "https://www.wm.com/us/en/dumpster-rental/40-yard",
  isRelatedTo: [
    "10 Yard Dumpster",
    "12 Yard Dumpster",
    "15 Yard Dumpster",
    "20 Yard Dumpster",
    "30 Yard Dumpster",
  ],
  brand: { "@type": "Brand", "@id": "https://www.wm.com/#brand" },
}
